import { format, isToday, isSameYear } from "date-fns";

/**
 * Formats a date for display in a compact form:
 */
export function formatLastKnownTime(
  date: string | Date | null | undefined,
): string {
  if (!date) {
    return "";
  }

  try {
    const dateObj = typeof date === "string" ? new Date(date) : date;

    if (isToday(dateObj)) {
      return format(dateObj, "h:mm aaa");
    }

    if (isSameYear(dateObj, new Date())) {
      return format(dateObj, "MM/dd");
    }

    return format(dateObj, "MM/dd/yyyy");
  } catch {
    return "";
  }
}
